import React from 'react';
import { useStateValue } from '../../contexto/store';
import { Route, Redirect } from 'react-router-dom';
import { matchPath } from 'react-router-dom';

function RutaSegura({ component: Component, ...rest }) {
  const [{ sesionUsuario }] = useStateValue();
  const rutaActual = rest.location.pathname;
  var arrRolPuedeVer = null;
  if (sesionUsuario) {
    const pantallasRol =
      sesionUsuario.usuario.pantallasUsuario.listaPantallasRol;
    //FC: La siguiente linea filtra el array <pantallasRol> y si encuentra coincidencias con la <rutaActual>
    //FC: se guardará en <arrRolPuedeVer>
    // arrRolPuedeVer = pantallasRol.filter(
    //   (pantallazo) => pantallazo.path === rutaActual
    // );
    
    // zinri: Si la ruta actual matchea con pantallazo.path aunque tenga parámetros, lo acepto.
    arrRolPuedeVer = pantallasRol.filter((pantallazo) =>
  matchPath(rutaActual, {
    path: pantallazo.path,
    exact: false,
    strict: false,
  })
);

  }
if (sesionUsuario) {

}

  return (
    <Route
      {...rest}
      render={(props) =>
        sesionUsuario ? (
          sesionUsuario.autenticado === true ? (
            arrRolPuedeVer.length > 0 ? (
              <Component {...props} {...rest} />
            ) : (
              <Redirect to="/prohibido" />
            )
          ) : (
            <Redirect to="/login" />
          )
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
}
export default RutaSegura;
